<a class="nav-link position-relative overflow-hidden" href="#" (click)="startTour()" [hidden]="hideRestartLink">Start Tour</a>
